import { useQueryClient } from 'react-query';
import { ProfileType, ProfileResponse } from 'services/requests';
import { useGetProfile } from 'hooks/api/login';
import { QueryKeys } from 'constants/queryKeys';

export enum Role {
  Admin = 'Admin',
  User = 'User',
}

export const useRole = () => {
  useGetProfile();
  const queryClient = useQueryClient();
  const profileType = queryClient.getQueryState<ProfileResponse>(QueryKeys.profile)?.data
    ?.profileType;

  const getRole = () => {
    switch (profileType) {
      case ProfileType.STAFF:
        return Role.Admin;
      default:
        return undefined;
    }
  };

  const role = getRole();
  const isAdmin = role === Role.Admin;

  return { isAdmin, role };
};
